import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/doctor-visit-cost/`;

export const doctorVisitCost = {
  get: () => generateApiPath(pathBase),
};
